import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../axiosinterceptor";

const initialState = {
  documentViewer: {
    documentViewerData: [],
    documentViewerDataError: "",
    documentViewerDataLoader: false,
  },
  // documentViewerSearch: {
  //   documentSearchValue: "",
  //   documentSearchValueLoading: false,
  //   documentSearchValueError: null
  // },
  selectedEpisode: {},
  documentviewerSearchValue: "",
  documentviewerEventKey: null,
  documentviewerCurrentPage: 1,
  episodeIdentifierTopassDocumentViewer: "",
  documentviewerSelectedDocumentData: {
    documentID: null,
    documentContent: "",
    documentName: "",
  },
  loadedDocuments: {
    uploadedDocumentsLoading: false,
    uploadedDocumentsData: [],
    uploadedDocumentsError: null,
  },
  uploadedS3DocumentObj: {
    uploadedS3DocumentLoading: false,
    uploadedS3DocumentData: {},
    uploadedS3DocumentError: null,

  }
};

export const getDocumentViewerData = createAsyncThunk(
  "document/getDocumentViewerData",
  async (
    { documentEpisodeIdentifier, documentCurrentPage },
    { dispatch, fulfillWithValue, rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.get(
        // `https://x1lme0i16h.execute-api.ap-southeast-2.amazonaws.com/test_demo_get_documents?episode_identifier=${documentEpisodeIdentifier}&pageNumber=${documentCurrentPage}`
        `/test_reasoning_coding?episode_identifier=${(
          documentEpisodeIdentifier || ""
        ).trim()}&pageNumber=${documentCurrentPage}`
      );
      const { data } = response;
      // console.log(data, "repsonse111");
      return fulfillWithValue(data);
      // return data?.documents
    } catch (error) {
      console.error("Error fetching Documents:", error?.response?.data?.error);
      // dispatch(resetEpisodeIdentifier());
      return rejectWithValue(
        error.response?.data?.error || "No documents found"
      );
      // throw error?.response?.data?.error
    }
  }
);

// export const searchDocumentViewerData = createAsyncThunk(
//   "/searchDocumentViewerData",
//   async (payload, {fulfillWithValue, rejectWithValue}) => {
//     try {
//       const response = await axios.post(
//         "https://63ob9igt0k.execute-api.ap-southeast-2.amazonaws.com/test_search_document", payload
//       );
//       const data = JSON.parse(response?.data?.body)
//       // console.log(data?.documents, 'datatat')
//       return fulfillWithValue(data?.documents);
//       // return data?.documents
//     } catch (error) {
//       console.error("Error fetching Documents:", error);
//       return rejectWithValue(error.response?.data?.message || "No documents found");
//       // throw error;
//     }
//   }
// );

const docProcessorUploadDEV =
  "https://rmfedbub99.execute-api.ap-southeast-2.amazonaws.com/doc_processor_upload";
const docProcessorUploadUSA =
  "https://uil3dyne33.execute-api.us-east-1.amazonaws.com/doc_processor_upload";
const docProcessorUploadINTERNAL =
  "https://refmfqmx3d.execute-api.ap-southeast-2.amazonaws.com/doc_processor_upload";

export const uploadDocumentsFunc = createAsyncThunk(
  "/uploadDocumentsFunc",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
      const docURL = process.env.REACT_APP_FLAG_DEV
        ? docProcessorUploadDEV
        : process.env.REACT_APP_FLAG_USA
        ? docProcessorUploadUSA
        : process.env.REACT_APP_FLAG_INTERNAL
        ? docProcessorUploadINTERNAL
        : "";
    try {

      const response = await axiosInstance.post(docURL, payload);
      return fulfillWithValue(response?.data?.uploads);
    } catch (error) {
      console.error("Error While Uploding Documents:", error);
      return rejectWithValue(
        error.response?.data?.message || "Error uploading documents"
      );
    }
  }
);

export const uploadDocumentToS3Func = createAsyncThunk(
  "/uploadDocumentToS3Func",
  async ({ url, formData}, { fulfillWithValue, rejectWithValue }) => {
    if (!url) {
      console.error("No upload URL found");
      return rejectWithValue("No upload URL found");
    }
    
    try {
      const uploadedS3DocumentResponse = await axios.post(url, formData, {
      headers: "multipart/form-data",
    })
      return fulfillWithValue(uploadedS3DocumentResponse);
    } catch (error) {
      console.error("Error while uploading documents to S3:", error);
      return rejectWithValue(
        error.response?.data?.message || "No documents uploaded"
      );
    }
  }
);

// export const uploadDocumentToS3Func = createAsyncThunk(
//   "/uploadDocumentToS3Func",
//   async ({ s3URL }, { fulfillWithValue, rejectWithValue }) => {
//     if (!s3URL) {
//       console.error("No upload URL found");
//       return;
//     }

//     try {
//       // Perform the upload
//       const response = await axios.put(s3URL)
//       console.log("Upload success ✅", res.status);
//        return fulfillWithValue(response)
//     } catch (error) {
//       console.error("Upload to S3 failed ❌", error?.response || error);
//     }
//   }
// );

const docfillAzureCredentialsDEV =
  "https://d9s0o8fekk.execute-api.ap-southeast-2.amazonaws.com/doc_processor_ec2_config_update";
const docfillAzureCredentialsUSA =
  "https://t1n0d68vx5.execute-api.us-east-1.amazonaws.com/doc_processor_ec2_config_update";
const docfillAzureCredentialsINTERNAL =
  "https://t0xzv3ttef.execute-api.ap-southeast-2.amazonaws.com/doc_processor_ec2_config_update";

export const fillAzureCredentials = createAsyncThunk(
  "/fillAzureCredentials",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    // console.log(payload, "payloadAzure");
     const docURL = process.env.REACT_APP_FLAG_DEV
        ? docfillAzureCredentialsDEV
        : process.env.REACT_APP_FLAG_USA
        ? docfillAzureCredentialsUSA
        : process.env.REACT_APP_FLAG_INTERNAL
        ? docfillAzureCredentialsINTERNAL
        : "";
    try {
      const response = await axiosInstance.post(
        docURL,
        {
          azure_config: {
            endpoint: payload.endPoint,
            key: payload.accessKey,
            AZURETENANTID: payload.tenantId,
            AZURECLIENTID: payload.clientId,
            AZURECLIENTSECRET: payload.clientSecret,
            AZURESUBSCRIPTIONID: payload.subscriptionId,
            AZURERESOURCEGROUP: payload.resourceGroup,
            AZUREACCOUNTNAME: payload.accountName,
          },
        }
      );
      console.log(response?.data?.uploads, "response");
      // console.log(response?.data?.uploads, 'response')
      return fulfillWithValue(response?.data?.uploads);
    } catch (error) {
      console.error("Error While Uploding Documents:", error);
      return rejectWithValue(
        error.response?.data?.message || "Error uploading documents"
      );
    }
  }
);
const documentViewerSlicer = createSlice({
  name: "documentViewerSlicer",
  initialState,
  reducers: {
    lastCodedEpisode: (state, action) => {
      state.selectedEpisode = action.payload;
    },
    setDocumentviewerPage: (state, action) => {
      state.documentviewerCurrentPage = action.payload;
    },
    setDocumentviewerSearchValue: (state, action) => {
      state.documentviewerSearchValue = action.payload;
    },
    resetDocumentviewerSearchValue: (state, action) => {
      state.documentviewerSearchValue = "";
    },
    setDocumentviewerEventKey: (state, action) => {
      state.documentviewerEventKey = action.payload;
    },
    setDocumentviewerSelectedDocumentData: (state, action) => {
      state.documentviewerSelectedDocumentData = action.payload;
    },
    setEpisodeIdentifierTopassDocumentViewer: (state, action) => {
      state.episodeIdentifierTopassDocumentViewer = action.payload;
    },
    resetDocumentViewerError: (state) => {
      state.documentViewer.documentViewerDataError = "";
    },
    resetEpisodeIdentifierTopassDocumentViewer: (state) => {
      state.episodeIdentifierTopassDocumentViewer = "";
    },
    resetDocumentViewerLoadedData: (state) => {
      state.documentViewer.documentViewerDataError = [];
    },
    clearUploadedDocumentsError(state) {
      state.loadedDocuments.uploadedDocumentsError = null;
    },
    resetdocumentS3Data: (state) => {
      state.uploadedS3DocumentObj.uploadedS3DocumentData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDocumentViewerData.pending, (state) => {
        state.documentViewer.documentViewerDataLoader = true;
        state.documentViewer.documentViewerDataError = "";
      })
      .addCase(getDocumentViewerData.fulfilled, (state, action) => {
        state.documentViewer.documentViewerData = action.payload;
        state.documentViewer.documentViewerDataLoader = false;
        state.documentViewer.documentViewerDataError = "";
      })
      .addCase(getDocumentViewerData.rejected, (state, action) => {
        state.documentViewer.documentViewerDataLoader = false;
        state.documentViewer.documentViewerDataError = action.payload;
        state.episodeIdentifierTopassDocumentViewer = "";
      })
      // .addCase(searchDocumentViewerData.pending, (state)=> {
      //   state.documentViewerSearch.documentSearchValueLoading = true;
      //   state.documentViewerSearch.documentSearchValueError = null;
      // }).addCase(searchDocumentViewerData.fulfilled, (state, action) => {
      //   state.documentViewerSearch.documentSearchValue = action.payload;
      //   state.documentViewerSearch.documentSearchValueLoading = false;
      // }).addCase(searchDocumentViewerData.rejected, (state, action) => {
      //   state.documentViewerSearch.documentSearchValueLoading = false;
      //   state.documentViewerSearch.documentSearchValueError = action.payload;
      // })
      .addCase(uploadDocumentsFunc.pending, (state) => {
        state.loadedDocuments.uploadedDocumentsLoading = true;
        state.loadedDocuments.uploadedDocumentsError = null;
      })
      .addCase(uploadDocumentsFunc.fulfilled, (state, action) => {
        state.loadedDocuments.uploadedDocumentsData = action.payload;
        state.loadedDocuments.uploadedDocumentsLoading = false;
      })
      .addCase(uploadDocumentsFunc.rejected, (state, action) => {
        state.loadedDocuments.uploadedDocumentsLoading = false;
        state.loadedDocuments.uploadedDocumentsError = action.payload;
      })
      .addCase(uploadDocumentToS3Func.pending, (state) => {
        state.uploadedS3DocumentObj.uploadedS3DocumentLoading = true;
        state.uploadedS3DocumentObj.uploadedS3DocumentError = null;
      })
      .addCase(uploadDocumentToS3Func.fulfilled, (state, action) => {
        state.uploadedS3DocumentObj.uploadedS3DocumentData = action.payload;
        state.uploadedS3DocumentObj.uploadedS3DocumentLoading = false;
      })
      .addCase(uploadDocumentToS3Func.rejected, (state, action) => {
        state.uploadedS3DocumentObj.uploadedS3DocumentLoading = false;
        state.uploadedS3DocumentObj.uploadedS3DocumentError = action.payload;
      });
  },
});
export const {
  lastCodedEpisode,
  setDocumentviewerPage,
  setDocumentviewerSearchValue,
  setDocumentviewerEventKey,
  setDocumentviewerSelectedDocumentData,
  setEpisodeIdentifierTopassDocumentViewer,
  resetDocumentViewerError,
  resetDocumentviewerSearchValue,
  resetDocumentViewerLoadedData,
  resetEpisodeIdentifierTopassDocumentViewer,
  clearUploadedDocumentsError,
  resetdocumentS3Data,
} = documentViewerSlicer.actions;

export default documentViewerSlicer.reducer;
